const waitForXrLoaded = (): Promise<void> =>
    new Promise((resolve) => {
        if (window.XR8?.XrController?.configure) {
            resolve();
            return;
        }

        const onLoaded = () => resolve();
        window.addEventListener('xrloaded', onLoaded, { once: true });
        window.addEventListener('XRloaded', onLoaded, { once: true });
    });

export const ensureXrController = async (): Promise<NonNullable<typeof window.XR8>> => {
    await waitForXrLoaded();

    const xr8 = window.XR8;
    if (!xr8) {
        throw new Error('XR8 is not available');
    }

    if (!xr8.XrController?.configure && xr8.loadChunk) {
        await xr8.loadChunk('slam');
    }

    if (!xr8.XrController?.configure) {
        throw new Error('XR8.XrController is not available');
    }

    return xr8;
};

export const registerXrExtras = () => {
    window.XRExtras?.AFrame?.registerXrExtrasComponents?.();
};
